import { Box, Select } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { useApiUrl } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import UserRole from "@warriortrading/warriortrading.hermes.common.feathers/enums/userRole";
import { useCallback, useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";

export const RoleBadgesAssignmentsCreate = () => {
    const {
        saveButtonProps,
        refineCore: { formLoading },
        register,
    } = useForm();

    const apiUrl = useApiUrl();
    const [badgeId, setBadgeId] = useState<string>("");
    const [badgeNameArr, setBadgeNameArr] = useState<{value: string; type: string}[]>([]);
    const badgeNameDataFun = useCallback(() => {
        return dataProvider(apiUrl)
        .getList({resource: "badge"})
        .then((res) => {
            if (res?.data && res?.data.length !== 0) {
                const roleArr = res.data.filter((item: any) => item['badgeType.name'] === "Role");
                const newRoleArr = roleArr.map((item: any) => {
                    return {
                        value: item.id,
                        type: item.name,
                    }
                })
                setBadgeNameArr(newRoleArr);
            }
            return res?.data;
        });
    }, [apiUrl]);
    const [role, setRole] = useState<number>();

    useEffect(() => {
        badgeNameDataFun();
        initialDataFun();
    }, [])

    const [initialList, setInitialList] = useState<{}[]>([]);
    const initialDataFun = useCallback(() => {
        return dataProvider(apiUrl)
        .getList({resource: "role-badges-assignments"})
        .then((res) => {
            if (res?.data) {
                setInitialList(res?.data);
            }
            return res?.data;
        });
    }, [apiUrl]);

    return (
        <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
            <Box
                component="form"
                sx={{ display: "flex", flexDirection: "column" }}
                autoComplete="off"
            >
                <FormControl fullWidth style={{marginTop: "10px", marginBottom: "10px"}}>
                    <InputLabel id="role">Role : </InputLabel>
                    <Select
                        {...register("role", {
                            required: "Choose a role",
                            validate: () => {
                                return  initialList.filter((item: any) => {
                                    return item.role === role;
                                })?.length === 0
                            }
                        })}
                        value={(role || role === 0) ? role as any : ""}
                        labelId="role"
                        label="Role"
                        error={role === undefined || initialList.filter((item: any) => {
                            return item.role === role;
                        })?.length !== 0}
                        onChange={(event: SelectChangeEvent) => {
                            setRole(event.target.value as any);
                        }}
                    >
                        {
                        Object.values(UserRole)[0].map((item: any) => {
                            return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>
                        })
                    }
                    </Select>
                    <FormHelperText>Each role can only have one Badge!</FormHelperText>
                </FormControl>
                <FormControl fullWidth style={{marginTop: "10px", marginBottom: "10px"}}>
                    <InputLabel id="badgeName">BadgeName : </InputLabel>
                    <Select
                        {...register("badgeId", {
                            required: "Choose a badgeId",
                        })}
                        value={badgeId ? badgeId : ""}
                        label="BadgeName"
                        error={badgeId === ""}
                        onChange={(event: SelectChangeEvent) => {
                            setBadgeId(event.target.value as any);
                        }}
                    >
                        {
                        badgeNameArr.map((item) => {
                            return <MenuItem key={item.value} value={item.value}>{item.type}</MenuItem>
                        })
                    }
                    </Select>
                    <FormHelperText>Choose a badgeId</FormHelperText>
                </FormControl>
            </Box>
        </Create>
    );
};